import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-zinc-700">
      <button
        className="w-full py-6 flex justify-between items-center text-left"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-white pr-8">{question}</h3>
        {isOpen ? (
          <ChevronUp className="text-amber-500 flex-shrink-0" size={24} />
        ) : (
          <ChevronDown className="text-gray-400 flex-shrink-0" size={24} />
        )}
      </button>
      {isOpen && (
        <div className="pb-6">
          <p className="text-gray-300 leading-relaxed">{answer}</p>
        </div>
      )}
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "How much does car detailing cost in Tralee?",
      answer: "Car detailing prices near Tralee vary by service level. At Kingdom Auto Detailing, our Maintenance Detail starts at €60, Full Detail from €150, and Ultimate Detail from €280. Ceramic coating packages range from €200 to €500 depending on duration of protection. We're just 15 minutes from Tralee town centre."
    },
    {
      question: "What is the best car detailing near Tralee?",
      answer: "Kingdom Auto Detailing is the top-rated car detailing service near Tralee. Serving Tralee and Co Kerry, we offer professional ceramic coating, paint correction, and full valeting services. We provide courtesy collection for Tralee customers."
    },
    {
      question: "Do you offer car valeting in Tralee?",
      answer: "Yes! We offer professional car valeting for Tralee customers with courtesy collection. Our Full Detail (from €150) includes complete interior and exterior cleaning. We serve Tralee, Ardfert, Fenit, and all surrounding areas within 15km."
    },
    {
      question: "Where can I get ceramic coating in Tralee?",
      answer: "Kingdom Auto Detailing offers professional ceramic coating near Tralee from €200. We provide 6 months to 7+ year protection options with hydrophobic, UV resistant coating. Serving Tralee and Co Kerry."
    },
    {
      question: "How often should I get my car detailed?",
      answer: "We recommend a Full Detail initially, then enrolling in our Maintenance Detail programme every 4-8 weeks to keep your car in pristine condition. Maintenance Detail customers receive 20% off larger packages. For ceramic coated vehicles, maintenance detailing helps preserve and extend the coating life."
    },
    {
      question: "What areas near Tralee do you serve?",
      answer: "We serve all of North Kerry including Tralee, Ardfert, Fenit, Listowel, Ballybunion, and surrounding areas. We offer courtesy collection within 15km of our Kerry service area - this includes most of Tralee."
    },
    {
      question: "What is paint correction and do I need it?",
      answer: "Paint correction (€51/hour) removes imperfections like swirl marks, light scratches, water spots, and oxidation from your car's paintwork. If your paint looks dull, has visible swirls in sunlight, or doesn't shine like it used to, paint correction can restore that showroom finish. It's recommended before ceramic coating for best results."
    },
    {
      question: "How do I book a car detailing appointment in Tralee?",
      answer: "You can book easily through our website booking form, call us at 089 653 6680, or message us on WhatsApp. We'll confirm your appointment and arrange collection from Tralee if needed. We recommend booking 2-3 days in advance, especially for full details and ceramic coating services."
    }
  ];

  return (
    <section className="py-16 px-4 bg-zinc-900" data-testid="faq-section">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl font-bold text-white text-center mb-4">
          Car Detailing Tralee - FAQ
        </h2>
        <p className="text-gray-400 text-center mb-12">
          Everything you need to know about car detailing near Tralee
        </p>
        
        <div className="bg-zinc-800 rounded-2xl p-6 md:p-8">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
            />
          ))}
        </div>
        
        <p className="text-center text-gray-400 mt-8">
          Still have questions?{' '}
          <a href="/contact" className="text-amber-500 hover:text-amber-400 underline">
            Contact us
          </a>{' '}
          or call{' '}
          <a href="tel:+353896536680" className="text-amber-500 hover:text-amber-400 underline">
            089 653 6680
          </a>
        </p>
      </div>
    </section>
  );
};

export default FAQ;
